import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import HowItWorks from '../components/HowItWorks';
import JsonLd from '../components/JsonLd';
import HomeHero from '../sections/HomeHero';
import HomeSEOText from '../sections/HomeSEOText';
import ServicesSection from '../sections/ServicesSection';
import WhyChooseSection from '../sections/WhyChooseSection';
import TestimonialsSection from '../sections/TestimonialsSection';
import CitiesSection from '../sections/CitiesSection';
import HomeBlogSection from '../sections/HomeBlogSection';
import CTASection from '../sections/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Marabout Sérieux en France ⭐ Faire Revenir Son Ex Rapidement - Résultats Garantis sous 7 Jours</title>
        <meta name="description" content="Grand marabout sérieux et efficace en France. Spécialiste retour affectif rapide garanti sous 7 jours. Faire revenir son ex, récupérer l'être aimé. Voyance sérieuse. Plus de 2400 clients satisfaits. Consultation gratuite 24h/24." />
        <meta name="keywords" content="faire revenir son ex, récupérer son ex, marabout efficace, marabout puissant, retour affectif rapide, retour affectif garanti, voyance sérieuse, marabout sérieux France, comment faire revenir son ex, rituel retour affectif, marabout qui marche vraiment, marabout Paris, marabout Marseille, marabout Lyon" />
        <link rel="canonical" href="https://maraboutserieux.com/" />
        <link rel="alternate" hrefLang="fr" href="https://maraboutserieux.com/" />
        <meta httpEquiv="content-language" content="fr" />
        <meta property="og:title" content="Marabout Sérieux en France - Faire Revenir Son Ex ⭐ Résultats Rapides Garantis" />
        <meta property="og:description" content="Grand marabout puissant et efficace. Faire revenir son ex rapidement. Résultats garantis sous 7 jours. 2400+ clients satisfaits. Voyance sérieuse." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://maraboutserieux.com/" />
        <meta property="og:locale" content="fr_FR" />
        <meta property="og:site_name" content="Marabout Sérieux" />
      </Helmet>

      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Marabout Sérieux",
        "url": "https://maraboutserieux.com",
        "telephone": "+33745449641",
        "description": "Grand marabout sérieux et efficace en France. Spécialiste du retour affectif rapide garanti. Voyance sérieuse.",
        "areaServed": { "@type": "Country", "name": "France" },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+33745449641",
          "contactType": "customer service",
          "availableLanguage": "French",
          "hoursAvailable": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
            "opens": "00:00",
            "closes": "23:59"
          }
        }
      }} />

      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Marabout Sérieux",
        "url": "https://maraboutserieux.com",
        "inLanguage": "fr-FR",
        "description": "Grand marabout sérieux et efficace en France. Retour affectif rapide garanti."
      }} />

      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "ProfessionalService",
        "name": "Marabout Sérieux - Grand Marabout Africain",
        "url": "https://maraboutserieux.com",
        "telephone": "+33745449641",
        "description": "Grand marabout puissant et efficace spécialisé dans le retour affectif rapide garanti sous 7 jours.",
        "priceRange": "€€",
        "address": { "@type": "PostalAddress", "addressCountry": "FR" },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "2400",
          "bestRating": "5",
          "worstRating": "1"
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Services de Marabout",
          "itemListElement": [
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Retour Affectif Rapide"}},
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Faire Revenir Son Ex"}},
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Voyance Sérieuse"}},
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Envoûtement Amoureux"}},
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Désenvoûtement"}},
            {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Protection Spirituelle"}}
          ]
        }
      }} />

      <Header />
      <HomeHero />
      <HomeSEOText />
      <ServicesSection />
      <HowItWorks />
      <WhyChooseSection />
      <TestimonialsSection />
      <CitiesSection />
      <HomeBlogSection />
      <FAQ />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
